import React from 'react';
import PortfolioUniversePage from './PortfolioUniversePage';

export default function TargetReturnPage() {
  return (
    <PortfolioUniversePage
      strategyId="target-return"
      portfolioHoldingType="TARGET_RETURN_PORTFOLIO"
    />
  );
}
